export const getUsername = state => {
  return state.username;
};

export const getAuthToken = state => {
  return state.authToken;
};

export const getAuthTokenExpiresIn = state => {
  return state.authTokenExpiresIn;
};

export const getRefreshToken = state => {
  return state.refreshToken;
};

export const getUserDisplayName = state => {
  if (state.userInfo) {
    return state.userInfo.name;
  }
};

export const getUserEmail = state => {
  if (state.userInfo) {
    return state.userInfo.email;
  }
};

export const getKidsInfo = state => {
  return state.kids;
};

export const userIsLoggedIn = (state, getters) => {
  return state.username !== null && getters.authToken !== null;
};
